import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation, withRouter } from 'react-router-dom';
import { Drawer, Modal, Menu } from 'antd';
import {
  LogoutOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import menu from '../menu';
import { logout } from '../redux/actions/AuthActions';

const { confirm } = Modal;

const AppDrawer = ({ visible, onClose }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { pathname } = location;

  const onLogout = () => {
    confirm({
      title: 'Are you sure to log out?',
      icon: <ExclamationCircleOutlined />,
      okText: 'OK',
      cancelText: 'Cancel',
      onOk: () => {
        dispatch(logout()).then(() => {
          window.location.href = '/login';
        });
      },
    });
  };

  const onClickMenu = (key) => {
    if (key === 'logout') {
      onLogout();
    } else if (key === 'profile') {
      history.push('/app/profile');
    } else {
      history.push(key);
    }
    onClose();
  };

  const drawerMenuItems = [
    ...menu,
    // {
    //   key: 'profile',
    //   label: 'Thông tin tài khoản',
    //   icon: <InfoCircleOutlined />,
    // },
    // {
    //   key: 'logout',
    //   label: 'Đăng xuất',
    //   icon: <LogoutOutlined />,
    // },
  ];

  return (
    <Drawer
      placement="left"
      closable={false}
      onClose={onClose}
      open={visible}
      zIndex={99999}
      bodyStyle={{ padding: 0 }}
    >
      <div style={{ display: 'flex', justifyContent: 'center', margin: '24px 16px' }}>
        <img
          style={{ height: 40, width: 'auto' }}
          src="/img/logo_Strong_Body.svg"
          alt="Logo"
        />
      </div>
      <Menu
        mode="inline"
        selectedKeys={[pathname]}
        style={{ height: 'calc(100% - 88px)', borderRight: 0, overflowY: 'auto' }}
        onClick={({ key }) => onClickMenu(key)}
        items={drawerMenuItems}
      />
    </Drawer>
  );
};

export default withRouter(AppDrawer);
